/**
 * @fileoverview Input/output schemas for world-set-ideation-v3.
 *
 * This agent generates ideas for staged environments (interiors, exteriors).
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldSetIdeaV3Schema, WorldSetElementEnum } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldElements.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldSets.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
  targetElement: WorldSetElementEnum.optional().describe(
    'Optional filter to generate only a specific element type (interior or exterior). If not provided, generates a mix.'
  ),
});

export type Input = z.infer<typeof InputSchema>;

const WorldSetIdeaOutputSchema = WorldSetIdeaV3Schema.omit({
  tempId: true,
  source: true,
});

export const OutputSchema = z.object({
  sets: z.array(WorldSetIdeaOutputSchema).describe('An array of generated world set ideas.'),
});

export type Output = z.infer<typeof OutputSchema>;
